import React, { useEffect } from 'react';
import './GinWelcomePage.css'
import LeftSideImg from '../../../../assets/Game/GinRummy/images/leftImg-welcome.png'
import RightSideImg from '../../../../assets/Game/GinRummy/images/rightImg-welcome.png'
import GinImage from '../../../../assets/Game/GinRummy/images/ginImage.png'
import Logo from '../../../../assets/Game/GinRummy/images/logoImg.png'
import Button from '../../../../components/GinGame/Button/Button';
import StatisticsImg from '../../../../assets/Game/GinRummy/images/statistics.png'
import SoundImg from '../../../../assets/Game/GinRummy/images/sound.png'
import BackArrowImg from '../../../../assets/Game/GinRummy/images/backArrow.png'
import SettingsImage from '../../../../assets/Game/GinRummy/images/settings.png'
import InfoImage from '../../../../assets/Game/GinRummy/images/infoImg.png'
import HelpImage from '../../../../assets/Game/GinRummy/images/helpImg.png'
import PlayGame from '../../../../assets/Game/GinRummy/images/playGame.png'
import { Container } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import { usePlayerToPlayerChkAddMutation } from '../../../../features/P2PFeatures/P2PCheckAdd/PlayerToPlayerSlice';
import Swal from "sweetalert2";
import { useDispatch } from 'react-redux';
import { saveFirstPlayerCard, saveScore, useUpdatePlayersCardP2PMutation } from '../../../../features/UserFeatures/Cards/cardsSave/CardsSaveSlice';

const GinWelcomePage = () => {
    const [fetchUpdateId] = useUpdatePlayersCardP2PMutation()
    const accessToken = localStorage.getItem("token");
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [playerToPlayerCheckAdd] = usePlayerToPlayerChkAddMutation()
    const startGameHandler = async () => {
        // console.log("modeles",model)
        navigate("/cards")
    }
    const multiplayerGameHandler = () => {
        navigate('/ginGameMultiplayer')
    }

const userId =localStorage.getItem("userId")
    const searchingOffData = {
        "UserId": userId,
        "IsOnline": false,
        "IsSearching": false,
        "lastGameEnd": new Date()
    }

    useEffect(() => {

        const handleBackButton = async() => {
           await playerToPlayerCheckAdd(searchingOffData)
        };    
        window.onpopstate = handleBackButton;
        return () => {
            window.onpopstate = handleBackButton;
        };
      }, []);
    //   const roomId = localStorage.getItem("roomId")
      const transformedData = {
        // roomId: "",
        userId: userId,
        playerCard: "",
        deckCard: "",
        openCard: "",
        player: "",
        roundCount: 0,
        turnPlayer: "",
        gameEndMessage : "Completed",
        isGameEnd : true,
        id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
        createdDate: new Date(),
        createdBy: "",
        modifiedDate: new Date(),
        isDeleted: true,
        isActive: true,
        deletedOn: new Date(),
        modifiedBy: "",
      };

        useEffect(() => {
        const rejoinCardData = async () => {
            const rejoindata = await fetch(`${process.env.REACT_APP_API_KEY}/GameScore/CheckPlayerToRejoinGameGin?UserId=${userId}`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${accessToken}`
                },
            }).then((res) => res.json())
            console.log("rejoindatarejoindata", rejoindata?.data)
            if (rejoindata?.status === 200) {
                Swal.fire({
                    title: 'You have an active game',
                    type: 'success',
                    text: `Would you like to rejoin`,
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Play',
                    cancelButtonText: "No!",
                    closeOnConfirm: false,
                    closeOnCancel: false
                }).then(function async (res) {
                    console.log("rekkkkkkk", res)
                    if (res.isConfirmed) {
                        dispatch(saveFirstPlayerCard([]))
                        dispatch(saveScore([]))
                        
                        const distributeCardsShow = fetch(`${process.env.REACT_APP_API_KEY}/GameScore/ShowPlayersCardForP2P?roomId=${rejoindata?.data?.roomId}&userId=${userId}&roundCount=${rejoindata?.data?.roundCount}`, {
                            headers: {
                              "Content-Type": "application/json",
                              "Authorization": `Bearer ${accessToken}`
                            },
                          }).then((response) => response.json())
                          .then((distributeCardsShow)=>{
                            console.log("distributeCardsShow",distributeCardsShow?.data)
                            dispatch(saveFirstPlayerCard(distributeCardsShow))
                            localStorage.setItem("userId2",distributeCardsShow?.data?.userId)
                            localStorage.setItem("userName2",distributeCardsShow?.data?.userName)
                          })
                          console.log("rejoindata?.data?.roomId",rejoindata?.data?.roomId)
                          localStorage.setItem("roomId",rejoindata?.data?.roomId)
                        //   const scoreDataa = fetch(`${process.env.REACT_APP_API_KEY}/GameScore/GetGameScore?RoomId=${rejoindata?.data?.roomId}`, {
                        //     headers: {
                        //       "Content-Type": "application/json",
                        //       "Authorization": `Bearer ${accessToken}`
                        //     },
                        //   }).then((res) => res.json())
                        //   .then((scoreDataa)=>{

                        //       console.log("scoreDataazzxz", scoreDataa)
                        //       dispatch(saveScore(scoreDataa))
                        //   })
                        //   setScoreDataFromAPI(scoreDataa)
                          navigate('/ginGameMultiplayer/multiplayer_Game')
                    }
                    else if (res?.isDismissed) {
                        console.log("iddddddd",rejoindata?.data?.roomId)
                        const updateData =  fetchUpdateId({roomId : rejoindata?.data?.roomId , ...transformedData})
                       console.log("transformedDatatransformedDatazzz",transformedData)
                    //    window.location.reload(false)
                    }
                });
            }
        }
        rejoinCardData()
    }, [])

    const backBtn=async()=>{
        await playerToPlayerCheckAdd(searchingOffData)
        navigate("/")
    }
    return (
        <>
            <section className='wrapper ginWelcomePage'>
                <div className='bgWelcome'>
                    <div className='main-section'>
                        <div className='text-center logoImage mb-4'>
                            <img src={Logo} alt="" />
                        </div>
                        <Container fluid>
                            <Row>
                                <Col sm={4} md={3} className='align-items-start d-flex flex-column justify-content-center'>
                                    <Button src={StatisticsImg} btnName="Statistics" />
                                    <Button src={SoundImg} btnName="Sound" />
                                    <Button src={BackArrowImg} btnName="Back" onClick={() =>backBtn() } />
                                </Col>
                                <Col sm={4} md={6} className='text-center img-fluid'>
                                    <img src={GinImage} className='img-fluid ginImg' alt="Gin game Image" />
                                </Col>
                                <Col sm={4} md={3} className='align-items-end d-flex flex-column justify-content-center'>
                                    <Button src={SettingsImage} btnName="Settings" />
                                    <Button src={InfoImage} btnName="About" />
                                    <Button src={HelpImage} btnName="Help" />
                                </Col>
                            </Row>
                            <Row className='justify-content-center mt-4'>
                                <Col md={6} className='align-items-center d-flex flex-column justify-content-center'>
                                    <Button onClick={startGameHandler} src={PlayGame} btnName="Vs computer" />
                                    <Button onClick={multiplayerGameHandler} src={PlayGame} btnName="Mutiplayer" />
                                    <Button src={BackArrowImg} btnName="Tournaments" />
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <img src={LeftSideImg} className='LeftSideImg' alt="" />
                    <img src={RightSideImg} className="RightSideImg" alt="" />
                </div>
            </section>
        </>
    )
}

export default GinWelcomePage;